export const LANG_FA_NAME = "fa";

export const LANG_FA_TRANS = {
  /* Select Language */
  lang_az: "آذربایجان",
  lang_en: "انگلیسی",
  lang_tr: "انگلیسی",
  lang_ru: "روسی",
  lang_fa: "فارسی",
  Turkey: "ترکیه",

  /* months days */
  0: "۰",
  1: "١",
  2: "۲",
  3: "۳",
  4: "۴",
  5: "۵",
  6: "۶",
  7: "۷",
  8: "۸",
  9: "۹",

  /********** BELGE TÜRLERİ **********/
  /* SATINALMA MODULU */
  PURCHASE_DISPATCH: "توزیع خرید",
  PURCHASE_RETURN_DISPATCH: "خرید بازپرداخت",
  PURCHASE_CONSIGNMENT_DISPATCH: "توزیع انبار خرید",
  PURCHASE_CONSIGNMENT_RETURN_DISPATCH: "بازپرداخت خرید بازپرداخت",
  PURCHASE_RETURN_INVOICE: "خرید صورت حساب بازپرداخت",
  PURCHASE_INVOICE: "فاکتور خرید",
  PURCHASE_RECEIVE_SERVICE_INVOICE: "خرید دعوت کننده خدمات دریافت",
  PURCHASE_RECEIVE_PROFORMA_INVOICE: "دریافت صورت حساب پروفرما",
  PURCHASE_PRICE_DIFF_INVOICE: "مبلغ هزینه خرید",
  PURCHASE_PRODUCER_INVOICE: "سازنده خرید خرید",
  PURCHASE_SERVICE_CARD: "کارت خدمات خرید",
  /*SATIŞ MODULU */
  SALES_INVOICE: "فاکتورهای فروش",
  SALES_SERVICE_CARD: "Verilen Hizmet Kartları",
  SALES_RETAIL_INVOICE: "Perakende Satış Faturası",
  SALES_RETAIL_RETURN_INVOICE: "Perakende Satış İade Faturası",
  SALES_WHOLESALE_INVOICE: "Toptan Satış Faturası",
  SALES_WHOLESALE_RETURN_INVOICE: "Toptan Satış İade Faturası",
  SALES_GIVEN_SERVICE_INVOICE: "Verilen Hizmet Faturası",
  SALES_GIVEN_PROFORMA_INVOICE: "Verilen Proforma Faturası",
  SALES_PRICE_DIFF_INVOICE: "Satış Fiyat Farkı Faturası",
  SALES_DISPATCH: "Satış İrsaliyeleri",
  SALES_RETAIL_DISPATCH: "Perakende Satış İrsaliyesi",
  SALES_RETAIL_RETURN_DISPATCH: "Perakende Satış İade İrsaliyesi",
  SALES_WHOLESALE_DISPATCH: "Toptan Satış İrsaliyesi",
  SALES_WHOLESALE_RETURN_DISPATCH: "Toptan Satış İade İrsaliyesi",
  SALES_CONSIGNMENT_DISPATCH: "Konsinye Çıkış İrsaliyesi",
  SALES_CONSIGNMENT_RETURN_DISPATCH: "Konsinye Çıkış İade İrsaliyesi",
  /* CARİ HESAP FİŞLERİ */
  CURR_ACCOUNT_REMITTANCE_RECEIPT: "Virman Fişi",
  CURR_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT: "Kur Farkı Fişi",
  CURR_ACCOUNT_CASH_COLLECTION: "Nakit Tahsilat",
  CURR_ACCOUNT_CASH_PAYMENT: "Nakit Ödeme",
  CURR_ACCOUNT_DEBIT_NOTE: "Borç Dekontu",
  CURR_ACCOUNT_CREDIT_NOTE: "Alacak Dekontu",
  /* MALZEME YÖNETİM FİŞLERİ */
  MATERIAL_SCRAP_RECEIPT: "Fire Fişi",
  MATERIAL_USAGE_RECEIPT: "Sarf Fişi",
  MATERIAL_SHORTAGE_STOCK_RECEIPT: "Sayım Eksiği Fişi",
  MATERIAL_EXCESS_STOCK_RECEIPT: "Sayım Fazlası Fişi",
  MATERIAL_WAREHOUSE_OUTPUT_RECEIPT: "Depo Çıkış Fişi",
  MATERIAL_WAREHOUSE_INPUT_RECEIPT: "Depo Giriş Fişi",
  MATERIAL_WAREHOUSE_TRANSFER_RECEIPT: "Depolar Arası Transfer Fişi",
  /* Kasa Fişleri */
  CASH_ACCOUNT_OPENING_RECEIPT_DEBIT: "Açılış Fişi (Borç)",
  CASH_ACCOUNT_OPENING_RECEIPT_CREDIT: "Açılış Fişi (Alacak)",
  CASH_ACCOUNT_REMITTANCE_RECEIPT_DEBIT: "Virman Fişi (Borç)",
  CURR_ACCOUNT_REMITTANCE_RECEIPT_CREDIT: "Virman Fişi (Alacak)",
  CURR_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT_DEBIT: "Kur Farkı Fişi (Borç)",
  CURR_ACCOUNT_EXCHANGE_DIFFERENCE_RECEIPT_CREDIT: "Kur Farkı Fişi (Alacak)",
  CURRENTACCOUNT_COLLECTION: "Cari Hesap Tahsilat",
  CURRENTACCOUNT_PAYMENT: "Cari Hesap Ödeme",

  /* ENUMS */
  ALL: "همه",
  INPUT: "ورودی",
  OUTPUT: "خروجی",
  CREDIT: "اعتبار",
  DEBIT: "بدهی",
  COMMERCIAL_GOODS: "Ticari Mal",
  PRODUCT: "Mamül",
  SEMI_PRODUCT: "Yarı mamül",
  RAW_MATERIAL: "Ham madde",
  MATERIAL: "Malzeme",
  SERVICE: "Hizmet",
  FUEL: "Akaryakıt",
  CURRENT_ACCOUNT_SELLER: "Müşteri / Satıcı",
  CURRENT_ACCOUNT: "Müşteri",
  SELLER: "Satıcı",
  MAIN_CURRENT_ACCOUNT: "Ana Cari",
  ACTIVE: "Aktif",
  PASSIVE: "Pasif",
  DISCOUNT: "İndirim",
  EXPENSE: "Masraf",
  PURCHASEMANAGER: "Satınalma Sorumlusu",
  SALESMANAGER: "Satış Sorumlusu",
  MATERIAL_CARD: "Malzeme Kartları",
  MATERIAL_RECEIPT: "Malzeme Yönetim Fişleri",
  CURRENT_ACCOUNT_CARD: "Cari Hesap Kartları",
  CURRENT_ACCOUNT_RECEIPT: "Cari Hesap Fişleri",
  CURRENT_ACCOUNT_RECEIPT_LINE: "Cari Hesap Fiş Satırları",
  CASH_ACCOUNT: "Kasa Kartları",
  CASH_ACCOUNT_RECEIPT: "Kasa Fişleri",
  YES: "Evet",
  NO: "Hayır",
  LOT: "Lot",
  SERIAL_NUM: "Seri No",
  NONE: "Yok",
  WEIGHTED: "Tartılı",
  COUNTLINE: "Adetli",
  PLU: "Plu",

  /* Toolbar / Grid /Genel */
  new: "جدید",
  copy: "نسخه",
  edit: "به روز رسانی",
  view: "نگاه",
  delete: "حذف",
  do_yes: "بله",
  do_no: "نه",
  do_reset: "پاک کردن",
  continue: "ادامه هید",
  go_back: "بازگشت",
  exit: "خروج",
  remove: "برداشتن",
  page: "صفحه",
  save: "صرفه جویی",
  save_and_new: "صرفه جویی",
  save_and_close: "Kaydet ve Kapat",
  close: "نزدیک",
  cancel: "لغو",
  ok: "خوب",
  apply: "درخواست دادن",
  add: "اضافه کردن",
  refresh: "تازه کردن",
  all_of: "همه",
  check_all: "انتخاب همه",
  uncheck_all: "همه را حذف کنید",
  list: "فهرست",
  lists: "لیست ها",
  export: "صادرات",
  excel_export: "Excel olarak",
  pdf_export: "PDF olarak",
  other: "دیگر",
  column_add_or_remove: "Kolon Ekle / Kaldır",
  field_add_or_remove: "Alan Ekle / Kaldır",
  loading: "بارگذاری",
  grid_design: "Grid Tasarımı",
  design: "Tasarım",
  new_design: "Yeni Tasarım",
  save_design: "Tasarımı Kaydet",
  save_design_or_load: "Tasarımı Kaydet/Yükle",
  saved_designs: "Kayıtlı Tasarımlar",
  save_new_design: "Yeni tasarım olarak kaydet",
  edit_design: "Tasarımı Düzenle",
  default_design: "Varsayılan Tasarım",
  save_as_default: "Öndeğer olarak kaydet",
  add_new_line: "Yeni Satır Ekle",
  add_line: "Satır Ekle",
  add_new_line_or_delete: "Yeni Satır Ekle / Sil",
  select: "انتخاب کنید",
  all: "Tümü",
  new_record: "Yeni Kayıt",
  edit_record: "Güncelleme",
  error: "خطا!",
  excel: "Excel",
  pdf: "Pdf",
  not_found: "پیدا نشد",
  in_out: "Giriş / Çıkış",
  search_value: "ارزش جستجو",
  search: "جستجو کردن",
  do_filter: "Lütfen filtreleme yapınız",
  billing_to: "Faturalaştır",
  saving: "Kaydediliyor",
  deleting: "Siliniyor",
  EQ: "Eşit",
  NOT_EQ: "Eşit değil",
  GT: "Büyük",
  GE: "Büyük eşit",
  LT: "Küçük",
  LE: "Küçük eşit",
  LIKE: "Benzer",
  NOT_LIKE: "Benzer değil",
  START_WITH: "İle başlar",
  END_WITH: "İle biter",
  IN: "İçeren",
  NOT_IN: "İçermez",
  BETWEEN: "Arasında",
  expression_eq: "Eşittir",
  expression_between: "Arasında",
  expression_in: "İçinde",
  couldnot_connect_server: "Sunucuya bağlanılamadı.",
  detail_filter: "Detaylı Filtre",
  details: "Detaylar",
  new_filter: "Yeni Filtre",
  create_new_design: "Yeni tasarım oluştur",
  filter_edit: "Filtre Güncelle",
  filter: "Filtre",
  filter_name: "Filtre Adı",
  field_list: "Alan Listesi",
  select_lang: "Dil seçiniz",
  select_all: "Tümünü seç",
  un_select_all: "Tümünü kaldır",
  view_source: "Kaynağı görüntüle",
  processing_is_working: "İşleminiz yapılıyor",
  value: "ارزش",
  important_area: "Bu alanın doldurulması gereklidir",
  bad_credentials: "Hatalı kullanıcı adı ya da şifre",
  couldnot_login: "Giriş yapılamadı",
  untitled_error: "Bilinmeyen bir hata meydana geldi.",
  default_language: "Varsayılan Dil",
  language: "زبان",
  username: "نام کاربری",
  forgot_pass: "رمز عبور را فراموش کرده اید",
  login_error: "Bir sorun oluştu lütfen tekrar deneyiniz",
  signin: "OTURUM AÇ",
  login: "ورود",
  logout: "خروج",
  wrong_mail_address_type: "Mail adresi yanlıştır",
  test_mail_send_success_message: "Test Maili Başarılı",
  test_mail_send_error_message: "Test Maili Başarısız",
  download_message_content: "Mesaj İçeriğini İndir",
  send_file: "Dosya Gönder",
  delete_message: "Mesajı Sil",
  invoice_status: "Fatura Durumu",
  current_account_is_closed_to_use: "Cari kullanıma kapalıdır",
  profile: "Profil",
  success: "موفقیت",
  success_message: "İşleminiz başarıyla gerçekleştirilmiştir",
  password_set_error: "Şifre oluşturulurken Hata oluştu",
  password_reset_error: "Şifre Sıfırlanırken Hata oluştu",
  password: "کلمه عبور",
  current_password: "رمز عبور فعلی",
  new_password: "رمز عبور جدید",
  new_password_confirmation: "Yeni Şifre Tekrarı",
  set_password: "Şifre oluştur",
  reset_password: "تنظیم مجدد رمز عبور",
  reset_my_password: "Şifre mi sıfırla",
  password_not_same: "Şifreler eşleşmiyor",
  send_reset_link_success_message:
    "Belirtmiş olduğunuz e-posta adresine şifre sıfırlama yönergelerini içeren mail gönderilmiştir. Lütfen mail kutunuzu kontrol ediniz.",
  reset_password_success_message:
    "Şifreniz başarılı bir şekilde sıfırlanmıştır",
  set_new_password_success_message:
    "Şifreniz başarılı bir şekilde kaydedilmiştir",
  password_change_success_message:
    "Şifreniz başarılı bir şekilde değiştirilmiştir",
  new_user: "Yeni Kullanıcı İsteği",
  user_create_send_mail:
    " e-posta adresine şifre oluşturma linki gönderilmiştir",
  help_center: "مرکز کمک",
  not_access_token_error: "Erişim İzniniz Bulunamadı!",
  end_date_cannot_be_less_than_start_date:
    "Bitiş tarihi başlangıç tarihinden küçük olamaz",
  lines: "Satırlar",
  line: "Satır",
  status: "وضعیت",
  type: "تایپ کنید",

  INVOICED: "صورت حساب شده",
  NOTINVOICED: "فاکتور نیست",
  FIXED: "درست شد",
  INCREMENTAL: "حیرت انگیز",
  GROUPEDINCREMENTAL: "Gruplanmış Artırımlı",
  BRANCHNO: "Şube No",
  WAREHOUSENO: "Depo No",
  USERCODE: "Kullanıcı Kodu",
  SERVICEPURCHASE: "Alınan Hizmet",
  SERVICESALES: "Verilen Hizmet",
  YEAR: "سال",
  MONTH: "ماه",
  WEEK: "هفته",
  DAY: "روز",
  HOURS: "ساعت ها",
  COMPANY: "شرکت",
  SUBCOMPANY: "زیرمجموعه",
  ROLE_ADMIN: "مدیر",
  ROLE_SUPERVISOR: "سرپرست",
  ROLE_USER: "کاربر",
  ROLE_GUEST: "مهمان",
  TRANSFERRER_BALANCE: "Devreden bakiye",
  debit: "بدهی",
  credit: "اعتبار",
  debit_credit: "اعتبار / بدهی",
  local_debit: "بدهی محلی",
  local_credit: "اعتبار محلی",
  unselected: "انتخاب نشده",
  add_shipping_address: "Sevkiyat Adresi Ekle",
  shipping_address: "Sevkiyat Adresleri",
  add_invoice_address: "Fatura Adresi Ekle",
  document_num: "Belge No",
  document_special_code: "Belge Özel Kodu",
  external_document_num: "Harici Belge No",
  current_account_name: "Cari Hesap Ünvanı",
  current_account_specode: "Cari Özel Kod",
  current_account_specode2: "Cari Özel Kod2",
  current_account_specode3: "Cari Özel Kod3",
  current_account_specode4: "Cari Özel Kod4",
  current_account_user: "Kayıt Yapan Kullanıcı",
  current_account_receipts: "Cari Hesap Fişleri",
  current_account_receipt: "Cari Hesap Fişi",
  current_account_reports: "Cari Hesap Raporları",
  current_account_extract: "Cari Hesap Ekstresi",
  current_account_balance_report: "Cari Hesap Bakiye Raporu",
  current_account_list_report: "Cari Hesap Liste Raporu",
  current_account_list: "Cari Hesap Listesi",
  last_transaction_date: "Son Hareket Tarihi",
  avarage_due_date: "Ortalama Vade Tarihi",
  due_date: "Vade Gün",
  processes: "İşlemler",
  process: "İşlem",
  messages: "Mesajlar",
  message: "Mesaj",
  exchange_rate: "Kur",
  exchange: "Döviz",
  warning: "Uyarı",
  surname: "Soyadı",
  name: "Adı",
  fullname: "Tam Adı",
  title: "Ünvanı",
  father_name: "Baba Adı",
  mother_name: "Anne Adı",
  birth_date: "Doğum Tarihi",
  birth_place: "Doğum Yeri",
  register_num: "Sicil No",
  identity_num: "Kimlik Numarası",
  gender: "Cinsiyet",
  nationality: "Uyruğu",
  religion: "Dini",
  marital_status: "Medeni Durumu",
  single: "Bekar",
  married: "Evli",
  separated: "Ayrılmış",
  divorced: "Boşanmış",
  widowed: "Dul",
  blood_group: "Kan Grubu",
  o_positive: "O Rh+",
  o_negative: "O Rh-",
  a_positive: "A Rh+",
  a_negative: "A Rh-",
  ab_positive: "AB Rh+",
  ab_negative: "AB Rh-",
  b_positive: "B Rh+",
  b_negative: "B Rh-",
  registered_population: "Nüfusa Kayıtlı Olduğu",
  person_id: "Kimliğin",
  volume_num: "Cilt No",
  family_num: "Aile Sıra No",
  sequence_num: "Sıra No",
  serial_num: "Seri No",
  serial_lot_description: "Seri/Lot Açıklama",
  serial_lot_num: "Seri/Lot No",
  serial_lot_transactions: "Seri/Lot Giriş Hareketleri",
  serial_lot_transaction: "Seri/Lot Giriş Hareketi",
  serial_lot_list: "Seri/Lot Listesi",
  transaction: "Hareket",
  transactions: "Hareketler",
  registration_num: "Kayıt No",
  given_place: "Verildiği Yer",
  given_date: "Verildiği Tarih",

  male: "Erkek",
  female: "Kadın",
  bank: "Banka",
  bank_account_num: "Banka Hesap Numarası",
  account_num: "Hesap Numarası",
  bank_branch: "Banka Şubesi",
  iban_num: "İban Numarası",
  iban: "İban",
  row_num: "Sıra No",
  number: "No",
  description: "Açıklama",
  branch: "Şube",
  dest_branch: "Karşı Şube",
  dest_branch_number: "Karşı Şube No",
  dest_warehouse_number: "Karşı Depo No",
  branch_name: "Şube Adı",
  brand: "Marka",
  brand_code: "Marka Kodu",
  materialSpecode: "Malzeme Özel Kodu",
  specode_description: "Özel Kod Açıklaması",
  specode_code: "Özel Kod Kodu",
  specode_type: "Özel Kod Türü",
  material_special_code: "Malzeme Özel Kodu",
  current_ccount_specode: "Cari Hesap Özel Kodu",
  bank_accounts: "Banka Hesapları",
  bank_account: "Banka Hesabı",
  specode: "Özel Kod",
  special_code: "Özel Kod",
  special_code2: "Özel Kod 2",
  special_code3: "Özel Kod 3",
  special_code4: "Özel Kod 4",
  special_code5: "Özel Kod 5",
  code: "Kodu",
  company: "شرکت",
  companies: "شرکت ها",
  input_quantity: "Giriş Miktarı",
  quantity: "کمیت",
  remaining_quantity: "Kalan Miktar",
  price: "قیمت",
  unit_price: "Birim Fiyatı",
  local_price: "Yerel Fiyatı",
  cost: "Masraf",
  tax_num: "Vergi No",
  tax_office: "Vergi Dairesi",
  address: "Adres",
  home_phone: "Ev Telefonu",
  mobile_phone: "Cep Telefonu",
  phone: "Telefon",
  phone2: "Telefon 2",
  fax_num: "Faks Numarası",
  email_address: "Mail Adresi",
  e_mail: "E-Posta Adresi",
  email: "Mail Adresi",
  send_test_mail: "Test Maili Gönder",
  subject: "Konu",
  receiver: "Alıcı",
  to_whom: "Kime",
  text: "Metin",
  company_email: "Şirket Maili",
  company_phone: "Şirket Telefonu",
  internal_phone: "Dahili No",
  web_address: "Web Adresi",
  trade_register_num: "Ticaret Sicil No",
  mersis_num: "Mersis No",
  web_service_address: "Web Servis Adresi",
  database_name: "Veritabanı Adı",
  server_name: "Sunucu Adı",
  port: "Port",
  use_ssl: "SSL Kullan",
  company_num: "Firma No",
  period_num: "Dönem No",
  branch_num: "Şube No",
  warehouse_num: "Depo No",
  picture: "Resim",
  pictures: "Resimler",
  country: "Ülke",
  region: "Bölge",
  territory: "Bölge",
  sales_territory: "Satış Bölgesi",
  sales_territories: "Satış Bölgeleri",
  state: "Eyalet",
  branch_region: "Bölge",
  city: "İl",
  town: "İlçe",
  village: "Köy / Kasaba",
  county: "İlçe",
  sector: "Sektör",
  day: "Gün",
  week: "Hafta",
  date: "Tarih",
  time: "Saat",
  month: "Ay",
  year: "Yıl",
  expiration_date: "Son Kullanma Tarihi",
  exp_date: "Son Kul. Tarihi",
  created_date: "Oluşturulma Tarihi",
  begin_date: "Başlangıç Tarihi",
  end_date: "Bitiş Tarihi",
  active_period: "Aktif Dönem",
  working_period: "دوره کاری",
  active_working_period: "دوره کار فعال",
  tooltip: "Bu kaydı seçerek hızlı işlem gerçekleştirebilirsiniz.",
  warehouse_can_not_be_same: "Giriş ve çıkış depoları aynı olamaz.",
  cash_account_can_not_be_same: "Giriş ve çıkış kasaları aynı olamaz.",
  company_or_period_not_set: "Şirket veya Çalışma dönemi doğru set edilmemiş",

  entry_info: "Kayıt Bilgisi",
  filter_count: "شمردن",
  short_name: "نام کوتاه",
  short_description: "Kısa Açıklama",
  unpurchasable: "Satınalma Yapılamaz",
  unpurchasable_order: "Satınalma Siparişi Açılamaz",
  current_account_type_not_valid: "Cari Hesap türü uygun değil",
  product_is_closed_to_use: "Ürün kullanıma kapalıdır",
  product_is_closed_to_purchasable: "Ürün satınalmaya kapalı",
  current_account_is_closed_to_purchasable: "Cari Hesap satınalmaya kapalı",
  product_is_closed_to_saleable: "Ürün satışa kapalı",
  current_account_is_closed_to_saleable: "Cari Hesap satışa kapalı",
  product_added: "Ürün eklendi",
  product_not_found: "Ürün bulunamadı",
  tracking_method: "Seri/Lot",
  category: "Kategori",
  shelf_life: "Raf ömrü",
  plu_num: "Plu No",
  producer_material_code: "Üretici Malzeme Kodu",
  origin: "Menşei",
  barcodes: "Barkodlar",
  material_responsibility: "Ürün Sorumluları",
  barcode: "Barkod",
  unit_type: "Birimi",
  payment_type: "Ödeme Tipi",
  product_manager: "Ürün Sorumlusu",
  unit_sets: "Birim Setleri Çarpanları",
  unit_set_code: "Birim Seti Kodu",
  unit_code: "Birim Kodu",
  multiplier: "Çarpan",
  sales_information: "Satış Bilgileri",
  purchase_information: "Satın Alma Bilgileri",
  un_saleable: "Satış Yapılamaz",
  un_saleable_order: "Satış Siparişi Açılamaz",
  un_transferable: "Transfer Edilemez",
  sales_unit: "Satış Birimi",
  purchase_unit: "Satınalma Birimi",
  un_purchaseable: "Satınalma Yapılamaz",
  un_purchaseable_order: "Satınalma Siparişi Verilemez",
  unit_name: "Birim Adı",
  shortName: "Kısa Adı",
  related_companies: "İlişkili Şirketler",
  overview: "بررسی اجمالی",
  erp_menu: "ERP Menü",
  admin_menu: "منوی مدیریت",
  favorites: "Sık Kullanılanlar",
  main_records: "Ana Kayıtlar",
  sales_personal: "فروش شخصی",
  sales_person_code: "کد فروشنده",
  employees: "کارکنان",
  employee: "کارمند",
  material_management: "مدیریت مواد",
  current_account_item_code: "Tedarikçi Malzeme Kodu",
  service_cards: "کارت های خدمات",
  service_card: "کارت خدمات",
  suppliers: "تامین کنندگان",
  purchase_management: "خرید",
  dispatch_date: "تاریخ اعزام",
  invoice_date: "تاریخ فاکتور",
  dispatch_first_date: "İrsaliye İlk Tarih",
  invoice_first_date: "Fatura İlk Tarih",
  dispatch_last_date: "İrsaliye Son Tarih",
  invoice_last_date: "Fatura Son Tarih",
  dispatch_num: "İrsaliye No",
  invoice_num: "Fatura No",
  receipt_no: "Fiş No",
  dispatches: "اعزام",
  purchase_dispatch: "اعزام خرید",
  purchase_dispatches: "اقلام خرید",
  purchase_invoice: "فاکتور خرید",
  purchase_invoices: "فاکتورهای خرید",
  sales_dispatch: "اعزام فروش",
  sales_dispatches: "نمایندگی فروش",
  sales_invoice: "فاکتور فروش",
  sales_invoices: "فاکتورهای فروش",
  invoices: "فاکتورها",
  buying_management: "Satınalma Yönetimi",
  sales_management: "مدیریت فروش",
  sales: "حراجی",
  finance_management: "مدیریت مالی",
  it_management: "BT Yönetimi",
  app_management: "Uygulama Parametreleri",
  dispatchInfo: "İrsaliye Bilgileri",
  finance: "دارایی، مالیه، سرمایه گذاری",
  definitions: "تعاریف",
  materials: "مواد",
  company_based_materials: "Şirket Bazında Malzemeler",
  material_definitions: "Malzeme Tanımları",
  cards: "کارت ها",
  sales_person: "فروشنده",
  units: "واحد ها",
  unit: "واحد",
  master_unit: "واحد کارشناسی ارشد",
  master_units: "واحد های کارشناسی ارشد",
  unit_set: "مجموعه های واحد",
  unit_set_units: "واحد واحد واحد",
  movements: "Hareketler",
  reports: "گزارش ها",
  report: "گزارش",
  extracts: "عصاره ها",
  extract: "استخراج کردن",
  brands: "علامت های تجاری",
  user_roles: "نقش کاربر",
  users: "کاربران",
  user: "کاربر",
  recording_user: "Kayıt Yapan Kullanıcı",
  role_permission: "Rol Yetkisi",
  role_permissions: "Rol Yetkileri",
  all_user: "تمام کاربر",
  active_user: "کاربر فعال",
  valid_for_all_users: "Tüm kullanıcılar için geçerli",
  user_role: "Kullanıcı Rolü",
  role_name: "Rol Adı",
  password_expired: "Parola Bitiş Tarihi",
  rayons: "روستاها",
  rayon: "rayon",
  rayon_code: "کد منطقه",
  special_codes: "کدهای ویژه",
  balance: "تعادل",
  isprivate_company: "Şahıs Şirketi",
  general: "عمومی",
  general_information: "اطلاعات کلی",
  amount_information: "مقدار اطلاعات",
  account_information: "Hesap Bilgileri",
  identity_information: "Kimlik Bilgileri",
  in_detail_information: "Detay Bilgileri",
  in_vat_information: "Vergi Oranları",
  contact_information: "İletişim Bilgileri",
  address_information: "Adres Bilgileri",
  other_information: "Diğer Bilgiler",
  commercial_information: "Ticari Bilgiler",
  params: "Parametreler",
  total: "Toplam",
  net_total: "Net Toplam",
  discount: "İndirim",
  vat: "KDV",
  vat_amount: "KDV Tutarı",
  vat_group: "KDV Grubu",
  vat_groups: "KDV Grupları",
  vat_group_name: "KDV Grup Adı",
  vat_rates: "KDV Oranları",
  vat_rate: "KDV oranları",
  vat_included: "KDV (D/H)",
  purch_vat_rate: "Alış KDV Oranı",
  sales_vat_rate: "Satış KDV Oranı",
  persale_vat_rate: "Perakende Satış KDV Oranı",
  persale_department: "Perakende Satış Departmanı",
  sales_department: "Topdan Satış Departmanı",
  working_periods: "Çalışma Dönemleri",
  workingPeriod: "Çalışma Dönemi",
  added: "Ekleyen",
  last_changed: "Son Değiştiren",
  sectors: "Sektörler",
  branches: "Şubeler",
  regions: "Bölgeler",
  warehouses: "Depolar",
  payment_plans: "Ödeme Planları",
  payment_plan: "Ödeme Planı",
  warehouse: "Depo",
  dest_warehouse: "Karşı Depo",
  email_settings: "E-Mail Ayarları",
  company_settings: "Şirket Ayarları",
  number_series: "Numara Serileri",
  vouchers: "Fişler",
  required_fields: "Zorunlu Alanlar",
  required_fields_must_be_entered: "Zorunlu Alanlar Girilmelidir",
  send_report: "Rapor Gönder",
  list_report: "Liste Raporu",
  matrix_report: "Matris Raporu",
  excel_report: "Excel Raporu",
  monitor_report: "Ekran Raporu",
  report_name: "Rapor Adı",

  bank_codes: "Banka Kodları",
  tax_houses: "Vergi Daireleri",
  current_account: "حساب جاری",
  current_accounts: "Cari Hesaplar",
  current_account_transaction: "Cari Hesap Hareketi",
  current_account_transactions: "Cari Hesap Hareketleri",
  material: "Malzeme",
  material_transaction: "Malzeme Haraketi",
  material_transactions: "Malzeme Haraketleri",
  material_management_receipt: "Malzeme Yönetim Fişi",
  material_management_receipts: "Malzeme Yönetim Fişleri",
  material_not_found: "Ürün bulunamadı",
  debit_and_credit_must_equals: "Borç ve alacak toplamları eşit olmalıdır",
  debit_and_credit_not_equals: "Borç ve alacak toplamları eşit değil",
  company_based_material: "Şirket Bazında Malzeme",

  NOACTION: "İşlem Yapılmayacak",
  CASH: "Nakit",
  CREDITCARD: "Kredit Kartı",
  PURCHASE_AMOUNT: "Döviz Alış",
  SALES_AMOUNT: "Döviz Satış",
  EFFECTIVE_PURCHASE_AMOUNT: "Efektif Alış",
  EFFECTIVE_SALES_AMOUNT: "Efektif Satış",
  EXCHANGE_BUYING: "Döviz Alış",
  EXCHANGE_SALES: "Döviz Satış",
  EFFECTIVE_BUYING: "Efektif Alış",
  EFFECTIVE_SALES: "Efektif Satış",
  currency_type: "Döviz Türü",
  line_type: "Türü",
  main_current_account: "Ana Cari",
  rate_calc_type: "Kur Türü",
  rate: "Oran",

  number_schema: "Numaralama Şablonları",
  document_type: "Belge Türü",
  document_date: "Belge Tarihi",
  document_time: "Belge Saati",
  last_no: "Son Numara",
  amount: "Tutar",
  local_amount: "Yerel Tutar",
  total_amount: "Tutar",
  local_total_amount: "Yerel Tutar",
  net_total_amount: "Toplam Tutar",
  gross_total_amount: "Tutar",
  number_schema_detail: "Numaralandırma Detayı",
  length: "Uzunluk Sayısı",
  property: "Özellik",
  start_no: "Başlangıç Numarası",
  end_no: "Bitiş Numarası",
  branch_undefined: "Şube bulunamadı.",
  not_match_length: "Girilen değer uzunluk alanından büyük olamaz",
  cant_blank_length: "Uzunluk boş bırakılamaz",
  select_first_company: "Şirket seçiniz.",
  select_and_continue: "Seç ve Yeni Satır",
  number_scheme_detail: "Numaralama Detayı",
  numberscheme: "Numaralama Şablonu",
  scales: "Terazi İlişkilendirme",

  material_status: "Malzeme Durumu",
  material_barcode: "Malzeme Barkodu",
  material_type: "Malzeme Tipi",
  material_code: "Malzeme Kodu",
  material_description: "Malzeme Açıklaması",
  material_specode: "Malzeme Özel Kod",
  material_specode2: "Malzeme Özel Kod 2",
  material_specode3: "Malzeme Özel Kod 3",
  material_specode4: "Malzeme Özel Kod 4",
  material_specode5: "Malzeme Özel Kod 5",
  material_user: "Kayıt Yapan Kullanıcı",
  specode_user: "Kayıt Yapan Kullanıcı",
  record_date: "Kayıt Tarihi",
  first_record_date: "İlk Kayıt Tarihi",
  first_date: "İlk Tarih",
  last_record_date: "Son Kayıt Tarihi",
  last_date: "Son Tarih",
  last_changed_user: "Son Değiştiren Kullanıcı",
  first_date_changed: "İlk Değiştirme Tarihi",
  last_date_changed: "Son Değiştirme Tarihi",
  cash_accounts: "Kasa Hesapları",
  cash_account_cards: "Kasa Kartları",
  cash_account_card: "Kasa Kartı",
  cash_account: "Kasa Hesabı",
  dest_cash_account: "Karşı Kasa",
  cash_account_no: "Kasa No",
  dest_cash_account_no: "Karşı Kasa No",
  cash_account_description: "Kasa Açıklaması",
  dest_cash_account_description: "Karşı Kasa Açıklaması",
  cash_account_receipts: "Kasa Fişleri",
  cash_account_receipt: "Kasa Fişi",
  cash_account_reports: "Kasa Raporları",
  bank_reports: "Kasa Raporları",
  company_number: "Firma No",
  company_description: "Firma Ünvanı",
  working_period_number: "Dönem No",
  working_period_description: "Dönem Adı",
  current_account_status: "Cari Hesap Durumu",
  current_account_type: "Cari Hesap Türü",
  current_account_code: "Cari Hesap Kodu",
  current_account_description: "Cari Hesap Ünvanı",
  branch_number: "Şube Kodu",
  branch_description: "Şube Adı",
  warehouse_description: "Depo Adı",
  warehouse_number: "Depo Kodu",
  current_account_tax_office: "Cari Hesap Vergi Dairesi",
  current_account_tax_no: "Cari Hesap Vergi No",
  current_account_identity_no: "Cari Hesap Tc No",
  current_account_payment_plan_code: "Cari Hesap  Ödeme Plan Kodu",
  current_account_country_description: "Cari Hesap Ülke",
  current_account_region_description: "Cari Hesap Bölge",
  current_account_city_description: "Cari Hesap İl",
  current_account_county_description: "Cari Hesap İlçe",
  current_account_address: "Cari Hesap Adres",
  current_account_phone: "Cari Hesap Tel",
  current_account_phone2: "Cari Hesap  Cep Tel",
  current_account_fax_no: "Cari Hesap  Fax No",
  current_account_email_address: "Cari Hesap  E-mail Adresi",
  current_account_web_address: "Cari Hesap  İnternet Adresi",
  current_account_sector_description: "Cari Hesap  Sektör",
  current_account_special_code: "Cari Özel Kod",
  current_account_special_code2: "Cari Özel Kod2",
  current_account_special_code3: "Cari Özel Kod3",
  current_account_special_code4: "Cari Özel Kod4",
  current_account_special_code5: "Cari Özel Kod5",
  material_receipt_document_types: "Malzeme Yönetim Belge Türü",
  purchase_document_types: "Satınalma Belge Türü",
  sales_document_types: "Satış Belge Türü",
};
